export default __webpack_public_path__ + "static/media/laptop.fa45b888.png";